import React from "react";
import propTypes from "prop-types";
import moment from "moment";
import { Form, Input, Message, Radio } from "semantic-ui-react";
import ConfirmModal from "../common/ConfirmModal";
import { DateInput } from "semantic-ui-calendar-react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { POST } from "../../frameworks/HttpClient";
import { URL_COMMON, URL_PURCHASE } from "../../constances";
import { Toast } from "../../frameworks/Toast";
import useDropdownItem from "../../frameworks/hooks/useDropdownItem";

let validationSchema = {
	product: Yup.string().required("เลือกสินค้าผิดพลาด"),
	transaction_type: Yup.string().required("กรุณากรอกข้อมูล"),
	amount: Yup.number().required("กรุณากรอกข้อมูล"),
	unit: Yup.string().required("กรุณากรอกข้อมูล"),
	due_date: Yup.string().required("กรุณากรอกข้อมูล"),
	department: Yup.string().required("ผู้ใช้งานไม่มีข้อมูลแผนก"),
}

export default function PurchaseModal(props) {
	const [loading, setLoading] = React.useState(false);
	const [errorMessages, setErrorMessages] = React.useState(null);
	const departmentOptions = useDropdownItem({url: URL_COMMON.DEPARTMENT});

	const formik = useFormik({
		enableReinitialize: true,
		validateOnChange: false,
		initialValues: {
			product: props.initialModel ? props.initialModel.id : null,
			transaction_type: "cash",
			is_control: false,
			is_eco_friendly: false,
			amount: "",
			unit: props.initialModel ? props.initialModel.unit : "",
			due_date: moment().format("YYYY-MM-DD"),
			department: localStorage.getItem('department') || "",
		},
		validationSchema: Yup.object(validationSchema),
		onSubmit: values => handleSubmit(values),
	});

	const handleSubmit = async (values) => {
		setLoading(true);
		try {
			await POST(URL_PURCHASE.PURCHASE_REQUEST, values);
			Toast.success("สำเร็จ")
			props.onClose();
		} catch (e) {
			setErrorMessages(e.errorMessages)
		} finally {
			setLoading(false);
		}
	}

	React.useEffect(() => {
		if (props.open) {
			setErrorMessages(null);
			formik.resetForm();
			departmentOptions.fetchData();
		}
	}, [props.open])

	return (
		<ConfirmModal 
			open={props.open}
			title={`สั่งซื้อ${props.initialModel ? ` [${props.initialModel.name}]` : ""}`}
			size={"tiny"}
			loading={loading}
			onClose={props.onClose}
			onCancel={props.onClose}
			onConfirm={formik.handleSubmit}
			detail={
				<div>
					{errorMessages && (
						<Message error content={errorMessages}/>
					)}

					<Form textAlign={"center"}>
						<Form.Group inline>
							<Form.Field width={4} label={"สินค้าที่ต้องการ"}/>
							<Form.Input
								width={12}
								style={{width: "100%"}}
								selection
								transparent
								readOnly={true}
								name={"product"}
								error={formik.errors.product}
								value={props.initialModel ? props.initialModel.name : ""}/>
						</Form.Group>

						<Form.Field label={"ประเภทการสั่งซื้อ"}/>
						<Form.Group inline>
							<Form.Field 
								width={4}
								control={Radio}
								label={"เงินสด"}
								name={"cash"}
								checked={formik.values.transaction_type === "cash"}
								onClick={(_, {name}) => formik.setFieldValue("transaction_type", name)}/>
							<Form.Field 
								width={4}
								control={Radio}
								label={"เครดิต"}
								name={"credit"}
								checked={formik.values.transaction_type === "credit"}
								onClick={(_, {name}) => formik.setFieldValue("transaction_type", name)}/>
							<Form.Field 
								width={4}
								control={Radio}
								label={"memo"}
								name={"memo"}
								checked={formik.values.transaction_type === "memo"}
								onClick={(_, {name}) => formik.setFieldValue("transaction_type", name)}/>
						</Form.Group>

						<Form.Field label={"ประเภทสินค้า"}/>
						<Form.Group inline>
							<Form.Field 
								width={4}
								control={Radio}
								label={"ควบคุม"}
								name={"is_control"}
								checked={formik.values.is_control}
								onClick={() => formik.setFieldValue("is_control", true)}/>
							<Form.Field 
								width={4}
								control={Radio}
								label={"ไม่ควบคุม"}
								name={"is_control"}
								checked={!formik.values.is_control}
								onClick={() => formik.setFieldValue("is_control", false)}/>
							<Form.Field width={4}/>
						</Form.Group>

						<Form.Field label={"ความเป็นมิตรต่อสิ่งแวดล้อม"}/>
						<Form.Group inline>
							<Form.Field 
								width={6}
								control={Radio}
								label={"เป็นมิตรต่อสิ่งแวดล้อม"}
								name={"is_eco_friendly"}
								checked={formik.values.is_eco_friendly}
								onClick={() => formik.setFieldValue("is_eco_friendly", true)}/>
							<Form.Field 
								width={6}
								control={Radio}
								label={"ไม่เป็นมิตรต่อสิ่งแวดล้อม"}
								name={"is_eco_friendly"}
								checked={!formik.values.is_eco_friendly}
								onClick={() => formik.setFieldValue("is_eco_friendly", false)}/>
						</Form.Group>

						<Form.Group inline>
						<Form.Field width={4} label={"จำนวนสั่งซื้อ"}/>
							<Form.Field 
								width={12}
								control={Input}
								type={"number"}
								placeholder={"จำนวน..."}
								name={"amount"}
								error={formik.errors.amount}
								value={formik.values.amount}
								onChange={formik.handleChange}/>
						</Form.Group>
						<Form.Group inline>
							<Form.Field width={4} label={"หน่วยที่สั่งซื้อ"}/>
							<Form.Field 
								width={12}
								control={Input}
								placeholder={"หน่วย..."}
								name={"unit"}
								error={formik.errors.unit}
								value={formik.values.unit}
								onChange={formik.handleChange}/>
						</Form.Group>

						<Form.Group inline>
							<Form.Field width={4} label={"กำหนดวันส่งสินค้า"}/>
							<Form.Field
								control={DateInput}
								dateFormat="YYYY-MM-DD"
								minDate={moment()}
								placeholder={"เลือกวันที่..."}
								name={"due_date"}
								error={formik.errors.due_date}
								value={formik.values.due_date}
								onChange={(_, data) => formik.setFieldValue(data.name, data.value)}/>
						</Form.Group>
						<Form.Group inline>
							<Form.Field width={4} label={"แผนกขอสั่งซื้อ"}/>
							<Form.Dropdown
								width={12}
								style={{width: "100%"}}
								selection
								placeholder={"กรุณาติดต่อเพื่อเพิ่มแผนกให้ผู้ใช้งาน"}
								options={departmentOptions.response}
								name={"department"}
								selectOnBlur={false}
								error={formik.errors.department}
								value={formik.values.department}
								onChange={(_, {name, value}) => formik.setFieldValue(name, value)}/>
						</Form.Group>
					</Form>
				</div>
			}/>
	)
}

PurchaseModal.defaultProps = {
	initialModel: null,
	open: false,
	onClose: () => {},
}

PurchaseModal.propTypes = {
	initialModel: propTypes.object,
	open: propTypes.bool,
	onClose: propTypes.func,
}